import { useContext } from 'react';
import { createPortal } from 'react-dom';
import { DefaultPortalContext } from '../../utilities/DefaultPortalContext';
export const Portal = ({ children, conditional = true, target, }) => {
    var _a;
    const defaultPortalContext = useContext(DefaultPortalContext);
    // Check for docuemnt for server-side rendered apps
    if (typeof document !== 'undefined') {
        // End early if portal isn't needed
        if (!conditional)
            return children;
        const node = (_a = target !== null && target !== void 0 ? target : defaultPortalContext) !== null && _a !== void 0 ? _a : document.body;
        return createPortal(children, node);
    }
    return null;
};
//# sourceMappingURL=Portal.js.map